import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes =[
  {
    path: '/',
    name: 'Home',
    component:resolve => require(['@/pages/Home'],resolve)//路由按需加载
  },
  //列表
  {
    path: '/List',
    name: 'List',
    component:resolve => require(['@/pages/List'],resolve)
  },
  //详情
  {
    path: '/Detail',
    name: 'Detail',
    component:resolve => require(['@/pages/Detail'],resolve)
  },
  //单页
  {
    path: '/InfoShow',
    name: 'InfoShow',
    component:resolve => require(['@/pages/InfoShow'],resolve)
  },
 
  //岗位招聘
  {
    path: '/JobsList',
    name: 'JobList',
    component:resolve => require(['@/pages/Job/JobList'],resolve)
  },
   {
    path: '/JobDetail',
    name: 'JobDetail',
    component:resolve => require(['@/pages/Job/JobDetail'],resolve)
  },
   {
    path: '/ApplyForPage',
    name: 'ApplyForPage',
    component:resolve => require(['@/pages/Job/ApplyForPage'],resolve)
  },
    //登录
  {
    path: '/Login',
    name: 'Login',
    component:resolve => require(['@/pages/GreenApply/Login'],resolve)
  },
  {
    path: '/Step1',
    name: 'Step1',
    component:resolve => require(['@/pages/GreenApply/Step1'],resolve)
  },
  {
    path: '/Step2',
    name: 'Step2',
    component:resolve => require(['@/pages/GreenApply/Step2'],resolve)
  },
  {
    path: '/Step3',
    name: 'Step3',
    component:resolve => require(['@/pages/GreenApply/Step3'],resolve)
  },
  //公示区
  {
    path: '/PublicityList',
    name: 'PublicityList',
    component:resolve => require(['@/pages/Publicity/PublicityLists'],resolve)
  },
  {
    path: '/PublicityDetail',
    name: 'PublicityDetail',
    component:resolve => require(['@/pages/Publicity/PublicityDetails'],resolve)
  },
  //搜索页面
  {
    path: '/Search',
    name: 'Search',
    component:resolve => require(['@/pages/Search'],resolve)
  },
  //下载页面
  {
    path: '/DownLoad',
    name: 'DownLoad',
    component:resolve => require(['@/pages/DownLoad'],resolve)
  },
  //资助信箱
  {
    path: '/MailBoxIndex',
    name: 'MailBoxIndex',
    component:resolve => require(['@/pages/MailBox/MailBoxIndex'],resolve)
  },
  // //筑梦飞翔爱心大礼包
  // {
  //   path: '/DreamHelp',
  //   name: 'DreamHelp',
  //   component:resolve => require(['@/pages/GreenApply/DreamHelp'],resolve)
  // },
 
  {
    path: '/NotFound',
    name: 'NotFound',
    component:resolve => require(['@/pages/NotFound'],resolve)
  },
  {
    path: '/NotFound4',
    name: 'NotFound4',
    component:resolve => require(['@/pages/NotFound4'],resolve)
  },
  {
    path: '/NotFound5',
    name: 'NotFound5',
    component:resolve => require(['@/pages/NotFound5'],resolve)
  },
 
]
const router =new Router({
  //mode:'history',
  routes, 
  base: "/" + document.location.pathname.split('/')[1] + "/",
  scrollBehavior (to, from, savePosition) {
    return { x: 0, y: 0 }
  }
});



export default router


// WEBPACK FOOTER //
// ./src/router/index.js